import PublicNav from '@/components/public/PublicNav';
import PublicFooter from '@/components/public/PublicFooter';
import { useReveal } from '@/hooks/useReveal';
import { useLang } from '@/i18n/LanguageContext';
import { PageMeta } from '@/components/PageMeta';

const f = "'IBM Plex Mono', monospace";

export default function SobrePage() {
  const { t } = useLang();
  const rTitle = useReveal(100);
  const rHighlight = useReveal(200);
  const rBlock1 = useReveal(200);
  const rBlock2 = useReveal(300);
  const rBlock3 = useReveal(400);

  const blocks = [
    { label: t('sobre.block1Label'), text: t('sobre.block1Text'), reveal: rBlock1 },
    { label: t('sobre.block2Label'), text: t('sobre.block2Text'), reveal: rBlock2 },
    { label: t('sobre.block3Label'), text: t('sobre.block3Text'), reveal: rBlock3 },
  ];

  return (
    <>
      <PublicNav />
      <PageMeta title={t('sobre.docTitle') as string} description={t('sobre.metaDesc') as string} />
      <main style={{ background: 'var(--lp-bg)', minHeight: '100vh', fontFamily: f, color: 'var(--lp-ink)' }}>
        <section
          className="lp-section"
          style={{ display: 'grid', gridTemplateColumns: '200px 1fr', borderTop: '0.5px solid var(--lp-border)' }}
        >
          <div
            className="lp-section-label split-label"
            style={{ borderRight: '0.5px solid var(--lp-border)', position: 'sticky', top: 72, alignSelf: 'start' }}
          >
            <div style={{ fontSize: 'var(--type-label)', letterSpacing: '0.14em', textTransform: 'uppercase', color: 'var(--lp-muted)' }}>
              <div>001</div>
              <div style={{ marginTop: 4 }}>{t('sobre.label')}</div>
            </div>
          </div>
          <div className="split-content">
            <div ref={rTitle.ref} style={rTitle.style}>
              <h1 style={{ fontSize: 'var(--type-h1)', fontWeight: 300, marginBottom: '3rem' }}>{t('sobre.title')}</h1>
            </div>

            <div ref={rHighlight.ref} style={rHighlight.style}>
              <p style={{
                fontSize: 'var(--type-h2)', fontWeight: 300, lineHeight: 1.8,
                color: 'var(--lp-ink)', marginBottom: '3rem', maxWidth: 540, whiteSpace: 'pre-line',
              }}>
                {t('sobre.highlight')}
              </p>
            </div>

            {blocks.map((block) => (
              <div key={block.label} ref={block.reveal.ref} style={{ ...block.reveal.style, borderTop: '0.5px solid var(--lp-border)', padding: '2rem 0' }}>
                <div style={{ fontSize: 'var(--type-label)', textTransform: 'uppercase', letterSpacing: '0.14em', color: 'var(--lp-muted)', marginBottom: '0.75rem' }}>
                  {block.label}
                </div>
                <p style={{ fontSize: 'var(--type-body)', lineHeight: 1.9, color: 'var(--lp-muted)', maxWidth: 500 }}>
                  {block.text}
                </p>
              </div>
            ))}
          </div>
        </section>
      </main>
      <PublicFooter />
    </>
  );
}
